<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Dkxzax/tc-custom/9780253006585.jpg?1731785169378" alt="This image is the cover for the book Euro Horror, New Directions in National Cinemas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Euro Horror, New Directions in National Cinemas
      </h1>
      <p class="bookDescription body article font2">
        <p>Beginning in the 1950s, "Euro Horror" movies materialized in astonishing numbers from Italy, Spain, and France and popped up in the US at rural drive-ins and urban grindhouse theaters such as those that once dotted New York's Times Square. Gorier, sexier, and stranger than most American horror films of the time, they were embraced by hardcore fans and denounced by critics as the worst kind of cinematic trash. In this volume, Olney explores some of the most popular genres of Euro Horror cinema—including giallo films, named for the yellow covers of Italian pulp fiction, the S&amp;M horror film, and cannibal and zombie films—and develops a theory that explains their renewed appeal to audiences today.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ian Olney
      </h2>
      
      <p class="authorDescription body article"><P>Ian Olney is Associate Professor of English at York College of Pennsylvania, where he teaches film studies. His publications on European cinema and horror film include articles in Quarterly Review of Film and Video and Literature/Film Quarterly.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Indiana University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a186cf44